import navigation from './navigations'

export default {
  navigation
}
